import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { MessageType } from "../../shared/constants";
import { Message } from "./messages.model";
import { UserAlertDTO, UserAlertsDTO } from "../../shared/DTO/UserAlertsDTO";
import { Observable } from "rxjs/Observable";
import { SessionStateService } from "../../core/services/session-state.service";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class MessagesService {
  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService
  ) {}

  cursor: string = null;

  getMessages(newGet?: boolean): Observable<any> {
    if (newGet === true) {
      this.cursor = null;
    }
    if (this.cursor !== undefined) {
      // console.log(`cursor de entrada: ${this.cursor}`);
      // console.log(this.sessionStateService.getHouse().houseId);
      let _url =
        "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/redymail/list?quantity=100";
      _url = this.cursor ? _url + "&cursor=" + this.cursor : _url;
      return this.apiService.get<UserAlertsDTO>(_url).map((messageDTO) => {
        // console.log(messageDTO);
        this.cursor = messageDTO.cursor;
        const _messages = messageDTO.messages;
        const messages: Message[] = [];
        _messages.forEach((a) => {
          // console.log(a);
          // console.log(Message.fromUserAlertDto(a));
          return messages.push(Message.fromUserAlertDto(a));
        });
        // console.log(`cursor de saida: ${messageDTO.cursor}`);
        return messages;
      });
    } else {
      return Observable.empty();
    }
  }

  getUnreadMessages(): Observable<any> {
    const _url =
      "/usermanagement/house/" +
      this.sessionStateService.getHouse().houseId +
      "/redymail/list?quantity=500";
    return this.apiService.get<UserAlertsDTO>(_url).map((messageDTO) => {
      if (messageDTO && messageDTO["messages"] !== undefined) {
        return messageDTO["messages"].filter((msg) => !msg.isRead).length;
      }
    });
  }

  setReadMessage(pkid: string, read: boolean): Observable<any> {
    const body = {
      isRead: read,
    };
    // /usermanagement/house/HOUSEID123/redymail/message?messageId=MESSAGEID123
    return this.apiService.patch(
      `/usermanagement/house/${
        this.sessionStateService.getHouse().houseId
      }/redymail/message?messageId=${pkid}`,
      body
    );
  }

  deleteMessage(pkid: string): Observable<any> {
    return this.apiService.delete(
      "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/redymail/message?messageId=" +
        pkid
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/messages/messages.service.ts